const FALLBACK = {
  semver: '0.0.0',
  commit: 'unknown',
  branch: 'unknown',
  describe: 'dev',
  dirty: false,
  label: 'dev',
};

let buildVersion = FALLBACK;

try {
  // eslint-disable-next-line global-require, import/no-unresolved
  buildVersion = require('../generated/buildVersion.json');
} catch {
  // Generated on `npm start` / `npm run build` via scripts/generate-version.js
}

export default buildVersion;
